import React, { useEffect, useRef } from "react";
import classNames from "classnames/bind";
import styles from "./NotFoundPage.module.css";
import images from "~/assets";
import { NavLink } from "react-router-dom";
import routes from "~/configs";

const cx = classNames.bind(styles);

function NotFoundPage() {
  const sectionTitleRef = useRef(null);

  const handleScroll = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = 78;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - headerHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(cx("visible"));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const titleRef = sectionTitleRef.current;
    if (titleRef) {
      observer.observe(titleRef);
    }

    return () => {
      if (titleRef) {
        observer.unobserve(titleRef);
      }
    };
  }, []);

  return (
    <div className={cx("site-wrapper")}>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
      />
      {/* <header className={cx("header")}>
        <h1 className={cx("logo")}>
          <img
            src={images.logo}
            alt="Xanh 19 Logo"
            className={cx("logo-imgs")}
          />
          Xanh19
        </h1>
        <nav className={cx("nav")}>
          <a href="#benefits" onClick={(e) => handleScroll(e, "benefits")}>
            Quyền lợi
          </a>
          <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
            Liên hệ
          </a>
          <NavLink to={routes.history}>Xem điểm</NavLink>
        </nav>
      </header> */}

      <div className={cx("container")}>
        <section className={cx("section", "highlight")}>
          <h3 className={cx("section-title")} ref={sectionTitleRef}>
            Trang Không Tồn Tại
          </h3>
          <div className={cx("form-container")}>
            <div className={cx("contact-text")}>
              <p>Rất tiếc, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.</p>
              <p>
                Vui lòng quay lại{" "}
                <NavLink to={routes.home} className={cx("contact-link")}>
                  trang chính
                </NavLink>{" "}
                hoặc liên hệ với chúng tôi để được hỗ trợ:
              </p>
              <p>
                <i className={cx("icon", "fa-solid", "fa-phone")}></i>
                Hotline:{" "}
                <a href="tel:0843348888" className={cx("contact-link")}>
                  0843 348 888
                </a>
              </p>
              <p>
                <i className={cx("icon", "fa-brands", "fa-facebook")}></i>
                Fanpage:{" "}
                <a
                  href="https://www.facebook.com/share/19aBsEnTai/"
                  className={cx("contact-link")}
                >
                  Xanh19 Group
                </a>
              </p>
            </div>
            <NavLink to={routes.home} className={cx("cta-btn")}>
              Quay Lại Trang Chính
            </NavLink>
          </div>
        </section>
      </div>
    </div>
  );
}

export default NotFoundPage;